import { postRequestWithToken, postFileRequestWithToken } from '.';
import Toast from '../utils/toast';

const Profile = async payload => {
  try {
    const profilePath = `/user_detail`;
    return await postRequestWithToken(profilePath, payload);
  } catch (error) {
    Toast('error', error?.response?.data?.message);
  }
};

const UpdateProfile = async payload => {
  try {
    const profilePath = `/update_profile`;
    return await postFileRequestWithToken(profilePath, payload);
  } catch (error) {
    Toast('error', error?.response?.data?.message);
  }
};

export const profileService = {
  Profile,
  UpdateProfile
};
